import { persistence } from '../services/persistence';

export type Language = 'en' | 'sv';

export function getLanguageFromBrowser(): Language {
  const stored = persistence.getItem('language') as Language | null;
  if (stored && (stored === 'en' || stored === 'sv')) {
    return stored;
  }

  if (typeof window === 'undefined') return 'en';

  const browserLang = navigator.language || (navigator as any).userLanguage;
  if (browserLang.startsWith('sv')) {
    return 'sv';
  }

  return 'en';
}

export function setLanguage(lang: Language): void {
  persistence.setItem('language', lang);
}

export function getLanguageFromPath(pathname: string): Language {
  const pathParts = pathname.split('/').filter(Boolean);
  if (pathParts[0] === 'sv') {
    return 'sv';
  }
  if (pathParts[0] === 'en') {
    return 'en';
  }
  return getLanguageFromBrowser();
}





